<template>
	<div class="pt-3 pl-5 pr-5">
		<div class="mb-2">
			<breadCrumb :routesArray="routesArray"></breadCrumb>
		</div>
		<div >
			<h1 class="font-bold">Course Details</h1>
		</div>
		<div>
			<!-- <div v-if="dotsLoading" class="mt-2">
				<div class="flex items-center justify-center w-full h-full skeleton mt-4 tableCornerRadius bg-white">
					<dots-loader />
				</div>
			</div>	 -->
		<div class="card mt-5 rounded responsiveCard flex items-center justify-center w-full h-16" v-if="dataLoading == true && completedCourse == false">
			<div class="cursor-pointer empty rowHeight">
				<div class="relative h-5">
					<div class="flex items-center justify-center w-full h-16 ">
						<dots-loader/>
					</div>
				</div>
			</div>
		</div>
		<div class="card mt-5 rounded responsiveCard" v-else>

			<div class="">
				<div v-if="courseDetails.courseImageUrl" class="h-full responsiveHeight" >
					<img  :src="courseDetails.courseImageUrl" class="card-bordered rounded-l-sm bg-cover bg-no-repeat bg-center h-full imageResponsive" />		
				</div>
				<div v-else class="h-full" :class="{'bg-primary rounded-l-sm flex justify-center items-center responsiveHeight1':!courseDetails.courseImageUrl}">
					<h1 class="text-white text-lg">{{courseDetails.courseName}}</h1>
				</div>
			</div>

			<div class="card-body courseInfo">
				<div class="details courseHeight flex flex-col h-full">
					<div class="flex flex-row">
						<h1 class="font-opensans">{{ courseDetails.courseName }}</h1>
					</div>
				<div class="textDivResponsive table-ellipsis text-grey mt-2 cursor-pointer flex-1" @mouseout="doFalse()">
						<p class="description font-opensans non-italic font-normal text-base text-black" @mousemove="toolTip( $event, courseDetails.courseDescription, 'text')">{{ courseDetails.courseDescription }}</p>
						<div v-if="toolTipActive">
          		            <tool-tip :tipText="toolTipText"></tool-tip>
        	            </div>
					</div>
					<div class="positionResponsive mt-2 " v-if="series[0] != 100 || series[0] == 100">
						<div class="flex items-center  mt-2">
                                <span class="text-xs font-semibold w-16">Start Date:</span>
                                <div class="startdate font-semibold flex justify-center items-center rounded font-opensans text-xs  h-5 border border-primary bg-primaryBg text-primary px-2">
                                    <div v-if="startedAt">{{startedAt}}</div>
                                    <div v-else>Not Started</div>
                                </div>
                        </div>
							<div class="flex items-center  mt-2">
                                <span class="text-xs font-semibold w-16" v-if="series[0] != 100">Due Date:</span>
                                <span class="text-xs font-semibold w-20" v-else>Completed:</span>
                            <div>
                            <div v-if="series[0]!=100" class="duedate font-semibold flex justify-center items-center rounded font-opensans text-xs  h-5  px-2 border border-error bg-highColor text-error">{{ userActivity.checkdueDate }}</div>
                            <div v-else class="duedate font-semibold flex justify-center items-center rounded font-opensans text-xs  h-5  px-2 border completedlablestyle">{{formatTime(userActivity.completedAt) }}</div>
                    </div>
                    </div>
					</div>
				</div>
				<div class="courseStatus">
					<div v-if="responsiveVariable == true" class="h-full w-full p-2">
						<div class="flex items-center justify-center chart relative">
							<apexchart width="200" height="200" type="radialBar" :options="chartOptions" :series="series"></apexchart>
						</div>
						<div class="flex items-center justify-center flex-col">
							<div class="btnprimary" @click="startCourse()" v-if="series[0] == 0 && startedAt == ''">Start</div>
							<div class="btnprimary" @click="startCourse()" v-else-if="series[0] == 100">Retake</div>
							<div class="btnprimary cursor-pointer" @click="startCourse()" v-else>Resume</div>

							<div>			
								<div class="btndisabled mt-3" v-if="series[0] != 100">Certificate</div>
								<div class="btnprimary mt-3" @click="downloadCerificate(userInfo)" v-else>
									<a >Certificate</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="positionResponsive mt-8" v-if="series[0] != 100">
					<div class="w-36 flex items-center btnpills rounded font-opensans text-xs font-semibold h-5 border border-primary bg-primaryBg text-primary px-2 mt-2">
						Start Date:{{ startedAt }}
					</div>
					<div class="w-36 flex items-center btnpills rounded font-opensans text-xs font-semibold h-5 border border-error bg-highColor text-error px-2 mt-2">
						Due Date:{{ userActivity.checkdueDate }}
					</div>
				</div>
				<div class="flex justify-between mt-8" v-else>
					<div class="rounded-full btnpills font-opensans text-xs font-bold  bg-green px-2 text-white">
						<span>Completed</span>
					</div>
					<div class="rounded-full btnpills font-opensans text-xs font-bold bg-gray px-2 text-white">
						<span>{{ completedBy }} </span>
					</div> -->
					<!-- <button class="rounded-full btnpills font-opensans text-xs font-bold bg-green text-white px-2">Completed</button> -->
					<!-- <p class="rounded-full btnpills bg-gray font-opensans text-xs font-bold text-white px-2">{{ completedBy }}</p> -->
				<!-- </div> -->
			</div>
			<div v-if="responsiveVariable == false" class="courseStatus">
				<div class="h-full w-full p-2">
					<div class="flex items-center justify-center chart relative">
						<apexchart width="200" height="200" type="radialBar" :options="chartOptions" :series="series"></apexchart>
					</div>
						<div class="flex items-center justify-center flex-col">
							<div class="btnprimary" @click="startCourse()" v-if="series[0] == 0 && startedAt == ''">Start</div>
							<div class="btnprimary" @click="startCourse()" v-else-if="series[0] == 100">Retake</div>
							<div class="btnprimary cursor-pointer" @click="startCourse()" v-else>Resume</div>

							<div>			
								<div class="btndisabled mt-3" v-if="series[0] != 100">Certificate</div>
								<div class="btnprimary mt-3"  @click="downloadCerificate(userInfo)" v-else>
									<a >Certificate</a>
								</div>
							</div>
					</div>
				</div>
			</div>
		</div>

		</div>
			<!-- <div class="flex justify-center items-center" v-else>
				<p>No Active Screens</p>
				</div> -->
				<!-- {{modules}} -->
		<div>
			<table class="tableCornerRadius rounded">
				<thead>
					<tr>
						<th class="header cursor-pointer flex items-center">
							Modules
						</th>
					</tr>
				</thead>
				<tbody v-if="dataLoading == true">
					<tr class="cursor-pointer empty rowHeight">
						<td class="relative h-5">
							<div class="flex items-center justify-center w-full h-16 ">
								<dots-loader/>
							</div>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr v-for="(module,index) in modules" :key="index">
						<td>{{ module.moduleName }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<style scoped>
.h-80{
	height: 380px;
}

.startdate{
	width: 88px;
}
.duedate{
	width: 88px;
}
table{
	margin-top: 20px;
}
p{
	font-size: 14px !important;
	line-height: 20px;
}
.w-20{
    width:68px;
}
.table-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 13;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.completedlablestyle{
	border-color: #00B050;
	background: #00b05033;
	color:#00B050 ;
}
/* @media (max-width: 830px) {
  .responsiveCard {
    flex-direction: column;
  }
} */
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { toast, emitter } from '../../main';
import VueApexCharts from 'vue3-apexcharts';
import breadCrumb from '@/components/breadCrumb.vue';
import dotsLoader from '@/components/dotsLoader.vue';
import toolTip from '@/components/toolTip.vue';
import moment from 'moment';
export default defineComponent({
	components: { apexchart: VueApexCharts,breadCrumb,dotsLoader,toolTip, },
	data(): any {
		return {
			courseDetails: {},
			modules: [],
			routesArray:[],
			userActivity: {},
			completedBy: '',
			closedroute: {},
			new_window: {},
			startedAt: '',
			responsiveVariable: false,
			seriesProgressData: [],
			completedCourse:false,
			allModulesNameArray:[],
            toolTipActive:false,
            toolTipText:'',
			chartOptions: {
				type: 'radialBar',
				colors: ['#1976d2'],
				labels: ['Course'],

				plotOptions: {
					radialBar: {
						// dataLabels: {
						// 	show: false
						// },

						dataLabels: {
							name: {
								show: false

								// fontSize: '17px'
							},
							value: {
								fontSize: '35px',
								show: true
							}
						},

						hollow: {
							margin: 15,
							size: '64%'
							// background: '#152a43'
						}
						// track:{
						// 	background: '#152a43'
						// }
					}
				}
			},

			series: [],
			dataLoading:true,
			screenWidth: window.innerWidth,
			dateResponsiveVariable:false,
			questionaire:[]
		};
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo'})
	},
	methods: {
		Images(payload: any) {
			console.log(payload.courseImageUrl);
			if (payload.courseImageUrl != '' && payload.courseImageUrl != undefined) {
				return payload.courseImageUrl;
			} else {
				return process.env.VUE_APP_COMMON_IMAGE;
			}
		},
		formatTime(time: any) {
            let now = moment(time);
            return now.format("DD-MM-YYYY");
        },

		async getAllModules() {
			this.allModulesNameArray = []
			let exam:any=[];
			const allQuestionaires = this.questionaire;
			await this.$http
				.get(`${process.env.VUE_APP_TRAINING_API_URL}/api/org/course/${this.$route.params.courseId}/modules/getAll`)
				.then(async (res: any) => {
					this.modules = res.data;
					this.modules.map((obj:any)=>{
						this.allModulesNameArray.push(obj.moduleName)
					})
					this.modules = this.modules.filter((module: any) =>{ return module.screens && module.isModuleActive == true});

					await this.$http.get(`${process.env.VUE_APP_TRAINING_API_URL}/user/${this.userInfo._id}/course/${this.$route.params.courseId}/userActivity`).then((a: any) => {
						this.userActivity = a.data[0];

						
						if (this.userActivity.updatedAt != undefined) {
						
							let date = new Date(this.userActivity.updatedAt);
							this.completedBy = (`0`+(date.getDate() )).slice(-2) + '-' + (`0`+(date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
					
						}else{
							this.completedBy =''
						}

						if(this.userActivity.examStatus){
							let date = new Date(this.userActivity.examStatus.startedAt);
							this.startedAt = (`0`+(date.getDate() )).slice(-2)+ '-' + (`0`+(date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
						}
						else if (this.userActivity.modules) {
							let date = new Date(this.userActivity.modules[0].updatedAt);
							this.startedAt = (`0`+(date.getDate() )).slice(-2)+ '-' + (`0`+(date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
						} 
						else {
							this.startedAt = '';
						}
						const date = new Date(this.userActivity.startedAt);
                        if(this.userActivity.startedAt){
                            this.startedAt =
							('0' + date.getDate()).slice(-2) + '-' +
							('0' + (date.getMonth() + 1)).slice(-2) + '-' +
							date.getFullYear();
                        }
                        else{
                            this.startedAt = '';
                        }

						exam = this.modules.filter((module:any)=>{
							this.questionaire = allQuestionaires.filter((ques:any)=>ques.moduleId == module._id && ques.isScreenActive == true);								
							return this.questionaire.length >0;
						});
						if(exam.length > 0 ){	
							if(this.userActivity.examStatus){
									this.userActivity.totalModules=this.userActivity.examStatus ? this.userActivity.totalModules+1:this.userActivity.totalModules+0
									var resultPercentage = Math.round((this.userActivity.examStatus.pass / this.userActivity.examStatus.total) * 100);
							if (resultPercentage < 80) {
									this.userActivity.completedModules=this.userActivity.completedModules+0
							} else {
									this.userActivity.completedModules=this.userActivity.completedModules+1
							}
							}else{
								this.userActivity.totalModules=this.userActivity.totalModules+1
							}
					
						}else{
							this.userActivity.totalModules=this.userActivity.totalModules+0
						}

						let moduleCompletion = Math.round((this.userActivity.completedModules / this.userActivity.totalModules) * 100) || 0;
						if(moduleCompletion>=100){
							moduleCompletion = 100
							this.completedCourse = true
						} else {
							this.completedCourse = false
						}
						this.series.push(moduleCompletion);
						// console.log("moduleCompletion",moduleCompletion)
					});
					this.completedCourse = true
				})
				.catch((error: any) => {
					toast.error(error, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				});
		},
		onExit(){
			window.close()
		},
		startCourse(module: any): any {
			var left = (screen.width - 900) / 2;
			var top = (screen.height - 600) / 4;
			let payload={
				totalModules:this.modules.length
			}
				this.$http
					.post(`${process.env.VUE_APP_TRAINING_API_URL}/user/${this.userInfo._id}/course/${this.$route.params.courseId}/updateModuleInUserActivity`, payload)
					.then((response: any) => {
					console.log(response)
					});
			
			// this.$router.push({
			// 	name: 'course-modules', params: { courseId: this.$route.params.courseId }
			// });
			let routeData = this.$router.resolve({ name: 'course-modules', params: { courseId: this.$route.params.courseId } });
			// window.open(routeData.href,"_blank", "width="+screen.availWidth+",height="+screen.availHeight)
			
     		 let pageWindow = window.open(routeData.href, '_blank', 'width=' + screen.availWidth + ',height=' + screen.availHeight);
      			if (pageWindow) {
        			// Listen for messages from Page B
        			window.addEventListener('message', this.handlePage);
      				}
 
			// window.open(routeData.href,'_blank','toolbar=yes,scrollbars=yes')
			// this.closedroute = window.open(routeData.href,'_blank,toolbar=yes,scrollbars=yes,resizable=yes');
			// this.new_window = window.open(routeData.href, '_blank', 'width=900, height=580, top=' + top + ',left=' + left + ',toolbar=yes,scrollbars=yes,resizable=yes fullscreen');
		},
			async handlePage(event:any) {
			if (event.data === 'pageClosed') {
				// Page B is closed, refresh Page A
				location.reload();
			}
			},
		async downloadCerificate(userInfo:any){
					this.$http({
                    url: `${process.env.VUE_APP_TRAINING_API_URL}/user/${userInfo._id}/course/${this.userActivity.masterCourseId}/certificate`, // File URL Goes Here
                    method: 'GET',
                    responseType: 'blob',
                }).then((res:any) => {
                     var FILE = window.URL.createObjectURL(new Blob([res.data]));
                     var docUrl = document.createElement('a');
                     docUrl.href = FILE;
                     docUrl.setAttribute('download', `${this.courseDetails.courseName}.pdf`);
                     document.body.appendChild(docUrl);
                     docUrl.click();
                });
			
		},
		// downloadCerificate:function(userInfo:any):any{
		// 	return `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_TRAINING_API_PATH}/user/${userInfo._id}/course/${this.userActivity.masterCourseId}/certificate`;
		// }
		handleResize() {
			this.screenWidth = window.innerWidth;
			if(this.screenWidth < 768){
				this.responsiveVariable = true
				console.log(`Screen width: `,this.screenWidth);
			} else {
				this.responsiveVariable = false
			}
		},
		toolTip( e: any, row: any, status: any) {
			this.tipText = row;
			switch (status) {
				case 'text':
					this.handleTextTooltip(e);
					break;
			}
		},
		handleTextTooltip(e: any) {
			const container = e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				let obj:any = {
					tipText : this.tipText
				}
				emitter.emit('activiteToolTip',obj)
			}
			//  else {
			// 	this.pop = false;
			// }
		},
		isTextOverflowed(element: any) {
			return element.scrollHeight > element.clientHeight;
		},
		doFalse() {
			emitter.emit('deActiviteToolTip')
		},
		async getallQuestionaireScreens() {
			this.questionaire=[];
			await this.$http.get(`${process.env.VUE_APP_TRAINING_API_URL}/api/org/course/questionaires/getall`).then((res: any) => {
				this.questionaire = res.data;
			});			
		},
	},

	async created() {
		await this.$http.get(`${process.env.VUE_APP_TRAINING_API_URL}/api/org/course/${this.$route.params.courseId}/get`).then((res: any) => {
			this.courseDetails = res.data[0];
		});
		window.addEventListener('resize', this.handleResize);
	},
	async mounted() {
		this.dataLoading = true;
		await this.getallQuestionaireScreens();
		await this.getAllModules();
		this.dataLoading = false;

		this.routesArray=[
			{name:'My Courses',routeName:'user_dashboard'},
			{name:this.courseDetails.courseName,routeName:'course-details'},
		]
		emitter.off('activiteToolTip');
		emitter.on('activiteToolTip', (data: any) => {
			this.toolTipActive = true;
			this.toolTipText = data.tipText
		});
		emitter.off('deActiviteToolTip');
		emitter.on('deActiviteToolTip', (data: any) => {
			this.toolTipActive = false;
			this.toolTipText = ''
		});
	},
	beforeUnmount() {
	// Clean up the event listener when the component is about to be unmounted
		window.removeEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
});
</script>